module.exports = __webpack_public_path__ + "img/beer_id-35.6abd36a5.png";